import { makeStyles } from '@material-ui/core';

export const getFormFieldStyles = makeStyles((theme) => ({
    formFieldContainer: {
        '&:empty': {
            display: 'none',
        },
        paddingBottom: theme.spacing(2),
        paddingTop: theme.spacing(2),
    },
    readOnlyField: {
        backgroundColor: theme.palette.primary.veryLight,
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'transparent', // Hides the border
        },
        '& .MuiOutlinedInput-input': {
            cursor: 'not-allowed',
        },
        '& .MuiFormLabel-asterisk': {
            color: theme.palette.error.main,
            fontSize: '1.5rem',
        },
    },
    editableField: {
        '& .MuiInputBase-root': {
            color: theme.palette.text.primary,
        },
        '& .Mui-disabled': {
            cursor: 'not-allowed',
        },
        '& .MuiFormLabel-asterisk': {
            color: theme.palette.error.main,
            fontSize: '1.5rem',
        },
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        spacing: 2,
    },
    hiddenField: {
        display: 'none',
    },
    fieldsTwoColumns: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '1rem',
    },
    error: {
        color: theme.palette.error.main,
    },
}));
